<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent max-width="400px">

      <v-card>
        <!-- title -->
        <v-card-title class="card-title">
          <span>에러가 발생했습니다.</span>
        </v-card-title>

        <!-- text -->
        <v-card-text>
          <span>에러가 발생했습니다. 다시 시도해주세요. ({{error_code}})</span>
        </v-card-text>

        <!-- actions -->
        <v-card-actions class="actions">
          <div class="actions">
            <v-btn small text @click="close()">
              Close
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  created() {
    this.$store.commit('error/setDialog', false)
    this.$store.commit('error/setErrorCode', null)
  },

  computed: {
    ...mapGetters({
      dialog: 'error/dialog',
      error_code: 'error/error_code',
    }),

    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  methods: {
    close() {
      this.$store.commit('error/setDialog', false)
      this.$store.commit('error/setErrorCode', null)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/modal/Error.vue